export default __webpack_public_path__ + "static/index_reason_hospital-81e6f5a05edf409a10355cf33411ee68.png";